import type { ShiftBreaksList } from '@libs/data-access/queries'
import Immutable from 'immutable'
import moment from 'moment'

import type { BreakRow } from '../../ShiftForm/components/BreakRowsContainer/BreakRowsContainer'

import { displayRulesLegacy } from './displayRulesLegacy'
import { getBreaksInfosLegacy } from './getBreaksInfosLegacy'

const defaultCases = (
  hasSnapPad,
  breakId,
  typeDuration,
  typeStart,
  typeEnd,
  breakAsReal,
  plannedDuration,
  shiftEventsSize,
  hasEmployeeModifyReal,
  shiftIsFinishedWithoutOut,
  padType
) => {
  if (!hasSnapPad || hasEmployeeModifyReal || shiftEventsSize === 0) {
    return {
      value: {
        id: breakId || null,
        plannedDuration: typeDuration,
        ...(typeStart
          ? {
              timeRange: [
                moment(typeStart).format('HH:mm'),
                moment(typeEnd).format('HH:mm')
              ]
            }
          : {})
      }
    }
  }
  if (!breakAsReal && (plannedDuration === 0 || shiftEventsSize < 1)) {
    return null
  }
  if (
    breakAsReal &&
    shiftEventsSize === 1 &&
    !shiftIsFinishedWithoutOut &&
    padType === 'break_event'
  ) {
    return null
  }
  return {
    value: {
      id: breakId || null,
      plannedDuration: typeDuration,
      ...(typeStart
        ? {
            timeRange: [
              moment(typeStart).format('HH:mm'),
              moment(typeEnd).format('HH:mm')
            ]
          }
        : {})
    }
  }
}

/**
 * @deprecated file
 */

export const getBreaksForFormLegacy = (
  shiftBreaks: ShiftBreaksList | undefined,
  hasSnapPad: boolean,
  breakAsReal: boolean,
  shiftIsFinishedWithoutOut: boolean,
  hasEmployeeModifyReal: boolean,
  clockInEvent: boolean,
  isShiftUnvalidate: boolean,
  padType: string
) => {
  return shiftBreaks && shiftBreaks?.size > 0
    ? shiftBreaks.map((shiftBreak, index) => {
        const hasPlanned =
          typeof shiftBreak?.get('planned_duration') === 'number'
        const hasReal = typeof shiftBreak?.get('real_duration') === 'number'

        const needReal =
          hasEmployeeModifyReal ||
          (hasEmployeeModifyReal === false && breakAsReal && clockInEvent) ||
          isShiftUnvalidate ||
          (hasPlanned &&
            hasReal &&
            shiftBreak.get('planned_duration') !==
              shiftBreak.get('real_duration'))

        const {
          plannedDuration,
          typeStart,
          typeEnd,
          typeDuration,
          shiftEventsSize
        } = getBreaksInfosLegacy(shiftBreak, needReal ? 'real' : 'planned')

        const edgeCase = displayRulesLegacy(
          // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
          shiftBreak?.get('id'),
          breakAsReal,
          shiftEventsSize,
          plannedDuration,
          shiftIsFinishedWithoutOut,
          typeStart,
          'real',
          index === 0,
          typeDuration,
          typeEnd,
          true,
          hasSnapPad
        )

        return edgeCase !== null
          ? (edgeCase as BreakRow[])
          : defaultCases(
              hasSnapPad,
              shiftBreak?.get('id'),
              typeDuration,
              typeStart,
              typeEnd,
              breakAsReal,
              plannedDuration,
              shiftEventsSize,
              hasEmployeeModifyReal,
              shiftIsFinishedWithoutOut,
              padType
            )
      })
    : Immutable.Iterable(null)
}
